import { Collection } from 'src/lib/fliko/types/database.type';

export class FirebaseCustomError {
  public constructor(
    public readonly error: unknown,
    public readonly writeData: Collection<any>
  ) {}
}
